import { graphql } from 'gatsby';
import Meta from 'gatsby-theme-core/src/layout/meta';

export * from 'gatsby-theme-core/src/layout/meta';

export const query = graphql`
  fragment PagesPageHead on STRAPI_PAGE {
    headPageTitle: page_title
    headMetaTitle: meta_title
    headTitle: title
    headSlug: slug
    headMetaDescription: meta_description
    headImage: image {
      url # needed for projection
      src: url
      height
      width
      localFile {
        childImageSharp {
          gatsbyImageData(layout: FIXED, width: 400, quality: 80)
        }
      }
    }
  }
`;

export default Meta;
